import React from 'react';
import { Link } from 'react-router-dom';
import { HiOutlineArrowLeft } from 'react-icons/hi';

const PrivacyPolicy = () => {
  return (
    <div style={{ background: 'var(--bg-primary, #f8fafc)', minHeight: '100vh', color: 'var(--text-primary, #0f172a)' }}>
      {/* Header */}
      <nav style={{
        position: 'sticky', top: 0, left: 0, right: 0, zIndex: 1000,
        padding: '16px 40px',
        background: 'rgba(255, 255, 255, 0.85)',
        backdropFilter: 'blur(20px)',
        borderBottom: '1px solid var(--border, #e2e8f0)',
        display: 'flex', alignItems: 'center'
      }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '8px', textDecoration: 'none', color: 'var(--text-secondary, #475569)', fontWeight: 600 }}>
          <HiOutlineArrowLeft size={20} /> Back to Home
        </Link>
      </nav>

      {/* Content */}
      <div style={{ maxWidth: '800px', margin: '40px auto', padding: '0 24px' }}>
        <h1 style={{ fontSize: '2.5rem', fontWeight: 800, marginBottom: '8px', color: 'var(--text-primary)' }}>Privacy Policy for TrackBells ERP</h1>
        <p style={{ color: 'var(--text-secondary)', marginBottom: '32px' }}>
          <strong>Effective Date:</strong> August 7, 2026<br />
          <strong>Company:</strong> Cyberbells ITES Services Pvt Ltd<br />
          <strong>Product:</strong> TrackBells Factory Automation ERP
        </p>

        <p style={{ lineHeight: 1.6, marginBottom: '24px' }}>
          This Privacy Policy describes how Cyberbells ITES Services Pvt Ltd ("we", "our", or "us") collects, uses, and protects your information when you use the TrackBells Factory Automation ERP platform (the "Service"). By using the Service, you agree to the collection and use of information in accordance with this policy.
        </p>

        <h2 style={{ fontSize: '1.5rem', fontWeight: 700, marginTop: '32px', marginBottom: '16px' }}>1. Information We Collect</h2>
        
        <h3 style={{ fontSize: '1.2rem', fontWeight: 600, marginTop: '24px', marginBottom: '8px' }}>1.1 Information You Provide to Us</h3>
        <ul style={{ paddingLeft: '24px', lineHeight: 1.6, marginBottom: '16px' }}>
          <li style={{ marginBottom: '8px' }}><strong>Account Information:</strong> When you register for an organization workspace, we collect your name, email address, phone number, and password.</li>
          <li style={{ marginBottom: '8px' }}><strong>Business Data:</strong> Data entered into the ERP, including but not limited to inventory, machine logs, sales, vendor information, and employee records.</li>
          <li style={{ marginBottom: '8px' }}><strong>Support Communications:</strong> Information you provide when contacting us for support or inquiries.</li>
        </ul>

        <h3 style={{ fontSize: '1.2rem', fontWeight: 600, marginTop: '24px', marginBottom: '8px' }}>1.2 Information Automatically Collected</h3>
        <ul style={{ paddingLeft: '24px', lineHeight: 1.6, marginBottom: '16px' }}>
          <li style={{ marginBottom: '8px' }}><strong>Usage Data:</strong> Information on how the Service is accessed and used (e.g., login timestamps, feature usage, IP addresses, browser types).</li>
          <li style={{ marginBottom: '8px' }}><strong>Device Information:</strong> We may collect information about the device you use to access our Service.</li>
        </ul>

        <h2 style={{ fontSize: '1.5rem', fontWeight: 700, marginTop: '32px', marginBottom: '16px' }}>2. How We Use Your Information</h2>
        <ul style={{ paddingLeft: '24px', lineHeight: 1.6, marginBottom: '24px' }}>
          <li style={{ marginBottom: '8px' }}>To provide and maintain our Service.</li>
          <li style={{ marginBottom: '8px' }}>To notify you about changes to our Service.</li>
          <li style={{ marginBottom: '8px' }}>To provide customer support.</li>
          <li style={{ marginBottom: '8px' }}>To ensure the security and integrity of our multi-tenant architecture.</li>
          <li style={{ marginBottom: '8px' }}>To detect, prevent, and address technical issues.</li>
        </ul>

        <h2 style={{ fontSize: '1.5rem', fontWeight: 700, marginTop: '32px', marginBottom: '16px' }}>3. Data Security and Isolation</h2>
        <p style={{ lineHeight: 1.6, marginBottom: '24px' }}>
          TrackBells ERP employs a strict Multi-Tenant SaaS architecture. We use robust security measures, including Database-level Data Isolation (via `organizationId`), role-based access control (RBAC), and encryption to protect your data. Your organization's data is completely isolated and cannot be accessed by other tenants on the platform.
        </p>

        <h2 style={{ fontSize: '1.5rem', fontWeight: 700, marginTop: '32px', marginBottom: '16px' }}>4. Account Deletion and Data Removal</h2>
        <p style={{ lineHeight: 1.6, marginBottom: '16px' }}>
          We understand your right to control your personal and organizational data. If you wish to delete your account or organization workspace from TrackBells ERP, please follow the process below:
        </p>
        <ul style={{ paddingLeft: '24px', lineHeight: 1.6, marginBottom: '24px' }}>
          <li style={{ marginBottom: '8px' }}><strong>How to Request Deletion:</strong> Send an email from your registered admin email address to <strong>info.cyberbells@gmail.com</strong> with the subject line "Account Deletion Request".</li>
          <li style={{ marginBottom: '8px' }}><strong>Processing Time:</strong> Once we receive your request, your account and all associated data will be permanently deleted from our servers <strong>within 24 hours</strong>.</li>
          <li style={{ marginBottom: '8px' }}><strong>Impact of Deletion:</strong> Please note that account deletion is irreversible. Once deleted, you will lose access to all inventory, production, sales, and employee data associated with your workspace.</li>
        </ul>

        <h2 style={{ fontSize: '1.5rem', fontWeight: 700, marginTop: '32px', marginBottom: '16px' }}>5. Third-Party Services</h2>
        <p style={{ lineHeight: 1.6, marginBottom: '24px' }}>
          We do not sell, trade, or rent your personal identification information to others. We may share generic aggregated demographic information not linked to any personal identification information regarding visitors and users with our business partners and trusted affiliates for the purposes outlined above.
        </p>

        <h2 style={{ fontSize: '1.5rem', fontWeight: 700, marginTop: '32px', marginBottom: '16px' }}>6. Changes to This Privacy Policy</h2>
        <p style={{ lineHeight: 1.6, marginBottom: '24px' }}>
          We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Effective Date" at the top. You are advised to review this Privacy Policy periodically for any changes.
        </p>

        <h2 style={{ fontSize: '1.5rem', fontWeight: 700, marginTop: '32px', marginBottom: '16px' }}>7. Contact Us</h2>
        <p style={{ lineHeight: 1.6, marginBottom: '24px' }}>
          If you have any questions about this Privacy Policy, your data, or if you need assistance, please contact us:
        </p>
        <ul style={{ paddingLeft: '24px', lineHeight: 1.6, marginBottom: '48px', listStyle: 'none', marginLeft: 0 }}>
          <li style={{ marginBottom: '8px' }}><strong>Email:</strong> <a href="mailto:info.cyberbells@gmail.com" style={{ color: 'var(--primary, #f97316)' }}>info.cyberbells@gmail.com</a></li>
          <li style={{ marginBottom: '8px' }}><strong>Phone:</strong> +919915865939</li>
          <li style={{ marginBottom: '8px' }}><strong>Company:</strong> Cyberbells ITES Services Pvt Ltd</li>
        </ul>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
